import request from '@/utils/request'
const Qs = require('qs')



// 获取geojson 数据
export function getDefectpGeojson() {
  return request({
    url: '/api/getDefectpGeojson',
    method: 'post'
  })
}
